export type BalanceResultMessageInput = {
  completed: boolean;
  answeredCount: number;
  wrongCount: number;
};

export function getBalanceResultMessage({
  completed,
  answeredCount,
  wrongCount,
}: BalanceResultMessageInput): string {
  if (completed && wrongCount === 0) return 'Tüm soruları doğru cevapladın. Harika iş!';
  if (!completed && answeredCount === 0) return 'Oyunu tamamlayamadın. Henüz hiçbir soruyu cevaplayamadın.';
  if (!completed && wrongCount === 0) return 'Oyunu tamamlayamadın fakat cevap verdiğin bütün sorular doğru.';
  return 'Hatalarını inceleyerek yeniden deneyebilirsin.';
}
